<template>
  <div>
    <el-dialog
      :visible.sync="noretira"
      width="360px"
      :top="'3vh'"
      :center="true"
      custom-class="modal-inner"
      :lock-scroll="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :destroy-on-close="false"
    >
      <div class="modalNoretira">
      <h3>Anulación del Pedido</h3>
     <p>
       Por favor indíquenos el motivo por el cual no va a retirar su pedido.
     </p>
     <p>
       Luego de validar los datos de su pedido procederemos a realizar la devolución de la compra.
     </p>
       <el-form :model="form" ref="form" :label-position="'top'" size="normal">
         <el-form-item label="Motivo" prop="motivo_no_retira" :rules="[{required: true, message:'requerido',trigger: 'blur'  }]">
           <el-input type="textarea" :rows="2" v-model="form.motivo_no_retira"></el-input>
         </el-form-item>
         <el-form-item>
           <el-button @click="cancelar">Cancelar</el-button>
           <el-button type="primary" :loading="enviando" @click="onSubmit('form')">Enviar solicitud</el-button>
         </el-form-item>
       </el-form>
       <!-- <small>ATENCIÓN: esta acción genera una solicitud de cancelación del pedido</small> -->
     </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { EventBus } from "@/event-bus";
import { HTTP } from "@/axios";
export default {
  props: ["datos"],
  data() {
    return {
      noretira: false,
      recopilando: true,
      form:{},
      enviando:false
    };
  },
  created() {
    EventBus.$on("verNoretira", (d) => {
      this.noretira = true;
    
    });
    //   EventBus.$on('enviarFormCancelar', (m) => {
    //       this.cancelar(m)
    //   })
  },
  computed: {
     ...mapGetters([
      "dataVtex",
      "iniciarReclamo",
      "pedidoCancelado",
      "messages",
      "numeroCaso",
      "mostrarChat",
      "fechaEntrega",
      "enTiempo",
      "dias30",
    ]),
  },
  methods: {
     ...mapActions({
      vuexIsloading: "isLoading",
      vuexprocesarReclamo: "procesarReclamo",
    }),
    onSubmit(formName)
    {
       this.$refs[formName].validate((valid) => {
          if (valid) {
            this.enviando = true
           this.procesarMotivo(14)
          } else {
            console.log('error submit!!');
            return false;
          }
        });
    },
      procesarMotivo(motivo) {
  
      let motivoIngresado = this.datos.motivos.filter((e) => e.id == motivo)[0];
      this.datos.motivo = motivoIngresado.motivo;
      console.log("motivoIngresado", motivoIngresado);

      let datosWc = {
        dni: this.datos.dni,
        email: this.datos.mail_d
          ? this.datos.mail_d
          : "",
        fechaVtex: this.$date(this.datos.vtex_fecha.date).format(
          "DD/MM/YYYY HH:mm"
        ),
        nombre: this.datos.nombre + " " + this.datos.apellido,
       telefono: this.datos.telefono,
        envio: this.datos.envio,
        totalOperacion: this.datos.importe / 100,
        wcTipo: motivoIngresado.wc_tipo ? motivoIngresado.wc_tipo : 0,
        vtex_id: this.datos.vtex_id,
        motivo_id: motivoIngresado.id ? motivoIngresado.id : 0,
        content: motivoIngresado.motivo ? `${motivoIngresado.motivo.toUpperCase()} <br> <strong>Motivo indicado por el cliente </strong> <br>${this.form.motivo_no_retira}` : `${this.form.motivo_no_retira}`,
        priority: "high"
      };

      this.datos.motivo_id = motivo;
     let result = this.vuexprocesarReclamo({ datosWc, motivoIngresado });
     result.then(res => {
       if(res.ok)
       {
         EventBus.$emit("procesarArrepentimiento", res);
       }
       else
       {
         this.$alert('No se pudo procesar el reclamo, por favor intente nuevamente', 'Error', {
           confirmButtonText: 'Aceptar',
           callback: () => {
             this.cancelar();
           }
         });
       }
     })
    
    },
    cancelar()
    {
      this.form = {}
      this.noretira = false
    }
  },
};
</script>


<style lang="scss" scoped>
.modalNoretira h3{
  margin: 0;
}
</style>